/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { SettingOutlined } from '@ant-design/icons'
import { Space } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { selectRoleListEvent, selectRoleActionEvent } from 'Store/manage-role/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction as clearRolePermissionEventAction } from 'Store/manage-role-permission/actions'
import { TableListPage } from 'Components/common/Table'
import { ActionButton } from 'Components/button'
import EventModal from 'Components/modal/EventModal'
import { selectRefreshPermissionEvent } from 'Store/manage-role-permission/selector'
import { getPackagesSpecAPI } from 'Store/pos/api'
import { PackagesSpecReq } from 'Store/pos/types'
import { selectPackagesSpec } from 'Store/pos/selector'
import PackageRolePermissions from './PackageRolePermissions'

type Props = {} & ReduxProps

const PackageRoles: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, list, refreshPermissionEvent } = props
  const dispatch = useDispatch()
  const [selectedID, setSelectedID] = useState(0)
  const [showManagePermission, setShowManagePermission] = useState(false)

  const [filter, setFilter] = useState({
    keyword: '',
    merchant_type: '',
    status: '',
    order_by: 'id',
    sort: 'desc',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 100,
  })
  const datas = list.data

  const onGetList = (): void => {
    const req: PackagesSpecReq = {}
    dispatch(getPackagesSpecAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
    }
  }, [])

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const onManageSuccess = () => {
    onGetList()
  }

  const clearRefreshEvent = (): void => {
    dispatch(clearRolePermissionEventAction())
  }

  const renderActionButton = (text: string, record: any) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<SettingOutlined />}
        label="จัดการ Roles"
        action="success"
        onClick={() => {
          setShowManagePermission(true)
          setSelectedID(record.id || 0)
        }}
      />
    </Space>
  )

  const columns = [
    // {
    //   title: 'ลำดับ',
    //   dataIndex: 'no',
    //   key: 'no',
    //   render: (value: any, record: any, index: number) => {
    //     return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
    //   },
    //   width: '60px',
    // },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '60px',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      //  render: renderCompanyInfo,
    },
    {
      title: '',
      key: 'action',
      render: renderActionButton,
      width: '100px',
    },
  ]

  const ManageDrawer = (
    <PackageRolePermissions
      mode={''}
      id={selectedID}
      visible={showManagePermission}
      onCloseDrawer={() => setShowManagePermission(false)}
      onSuccess={onManageSuccess}
    />
  )

  const RefreshLoadingModal = (
    <EventModal
      event={[refreshPermissionEvent]}
      enable={true}
      successCalback={clearRefreshEvent}
      errorCalback={clearRefreshEvent}
    />
  )

  return (
    <>
      <TableListPage
        columns={columns}
        datas={datas}
        isLoading={listEvent.IsLoading}
        paginationContent={null}
        onSort={onSort}
        scrollX={500}
        size="small"
      />
      {ManageDrawer}
      {RefreshLoadingModal}
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectPackagesSpec(state),
    listEvent: selectRoleListEvent(state),
    event: selectRoleActionEvent(state),
    refreshPermissionEvent: selectRefreshPermissionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PackageRoles)
